'use client';

import { Fragment, PropsWithChildren } from 'react';
import { useGiftcard } from 'context/giftcard';

import { PageTextContentContextProvider } from 'context/pageTextContent';
import { useRouter } from 'hooks/useRouter';
import { doesRouteMatch } from 'utils/helpers';
import { Paths } from 'utils/paths';
import {
  ActivationPage,
  ActivationSponsoredGiftcardSearchParams,
} from './ActivationPage';

interface Props extends PropsWithChildren {
  content: SponsoredGiftcardActivationPageContent;
}

export const SponsoredGiftcardActivation = (props: Props) => {
  const { content, children } = props;

  const { giftcard } = useGiftcard();

  const { query, pathname } =
    useRouter<ActivationSponsoredGiftcardSearchParams>();

  const isRedirected = !doesRouteMatch({
    route: pathname,
    signature: Paths.GIFTCARD_REDEEM_PAGE,
  });

  if (giftcard.isActivated && query.form === 'digital' && isRedirected) {
    return <Fragment key="giftcards-page">{children}</Fragment>;
  }

  return (
    <PageTextContentContextProvider content={content}>
      <ActivationPage />
    </PageTextContentContextProvider>
  );
};
